const inverterFormSchema = {
  type: 'object',
  required: ['siteId', 'name'],
  properties: {
    name: { type: 'string', minLength: 6, maxLength: 255 },
  },
};

export { inverterFormSchema };
